import { UrlForm } from '@/components/UrlForm';
import { useT } from '@/lib/useLang';

/**
 * Le bloc de fin de page, sur le modèle de « Your next post is the one to
 * boost. » de podawaa.com : un panneau sombre arrondi, une phrase, le
 * formulaire. Les arcs sont décoratifs.
 */
export function Cta() {
  const t = useT();

  return (
    <section id="cta" className="nz-cta nz-cta--dark">
      <div className="nz-cta__panel">
        <svg className="nz-cta__arcs" viewBox="0 0 400 400" aria-hidden="true" focusable="false">
          <circle cx="400" cy="0" r="140" />
          <circle cx="400" cy="0" r="220" />
          <circle cx="400" cy="0" r="300" />
        </svg>

        <div className="nz-cta__copy">
          <h2 className="nz-cta__h2">{t.ctaH2}</h2>
          <p className="nz-cta__p">{t.ctaP}</p>
          <div className="nz-cta__note">{t.ctaNote}</div>
        </div>

        <div className="nz-cta__form">
          <UrlForm id="cta-linkedin-url" />
        </div>
      </div>
    </section>
  );
}
